(function () {
  if (window.__mxcLoaded) return;
  window.__mxcLoaded = true;

  function measure() {
    var h = 0;
    var sel = ['.shopify-section-header', '.section-header', '.header-wrapper'];
    for (var i = 0; i < sel.length; i++) {
      var el = document.querySelector(sel[i]);
      if (el) { h = Math.round(el.getBoundingClientRect().height); break; }
    }
    document.documentElement.style.setProperty('--mxc-top', h + 'px');
  }

  function bindSelects() {
    var list = document.querySelectorAll('[data-mxc-go]');
    for (var i = 0; i < list.length; i++) {
      list[i].addEventListener('change', function (e) {
        if (e.target.value) window.location.href = e.target.value;
      });
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    measure();
    bindSelects();
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) {
      var el = document.querySelector('.shopify-section-header') ||
               document.querySelector('.section-header') ||
               document.querySelector('.header-wrapper');
      if (el) new ResizeObserver(measure).observe(el);
    }
    setTimeout(measure, 300);
  });
})();
